import React, { useState } from "react";
import "./DateSelector.scss";
import { ImCross } from "react-icons/im";

const DateSelector = ({ dates, tripTitle, onClose, onSelectDate, setSelectedDate, selectedDate, formData, setFormData }) => {
  const availableDates = JSON.parse(dates);
  // const [selectedDate, setSelectedDate] = useState(null);

  return (
    <div className="date-modal-overlay">
      <div className="date-modal">
        <button className="close-btn" onClick={onClose}>
          <ImCross />
        </button>

        <h2>Select Date</h2>
        <p className="trip-title">{tripTitle}</p>

        <div className="date-table">
          <div className="date-header">
            <span>Date</span>
            <span>Seats Left</span>
            <span>Price</span>
          </div>

          {availableDates.map((item, index) => (
            <div
              key={index}
              className={`date-row ${
                selectedDate?.dateRange === item.dateRange ? "active" : ""
              }`}
              onClick={() => {
                setSelectedDate(item)
                setFormData({
                  ...formData,
                  date: item.dateRange
                })
              }}
            >
              <span>{item.dateRange}</span>
              <span>{item.seatsAvailable} Seats</span>
              <span>${item.price}</span>
            </div>
          ))}
        </div>

        <button
          className="next-btn"
          disabled={!selectedDate}
          onClick={() => onSelectDate(selectedDate)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default DateSelector;
